import { Route, Switch } from "react-router-dom";
import "./../scss/WebHeliosen.scss";
import Header from "./Header";
import { useMediaQuery } from "react-responsive";
import Main from "./Main";
import MainHeliosen from "./MainHeliosen";

function Heliosen() {  
  const mobile = useMediaQuery({
    query: "(max-width : 1023px)",
  });

  return (
    <>
      <div className={mobile ? "mobile-wrap" : "wrap"}>
        <Header/>
        <>
          <Switch>
            <Route path="/" exact={true} component={Main} />
            <MainHeliosen/>
          </Switch>
        </>
      </div>
    </>
  );
}

export default Heliosen;
